import { render, staticRenderFns } from "./CharacterCounter.vue?vue&type=template&id=2f03a786&scoped=true"
import script from "./CharacterCounter.vue?vue&type=script&lang=js"
export * from "./CharacterCounter.vue?vue&type=script&lang=js"
import style0 from "./CharacterCounter.vue?vue&type=style&index=0&id=2f03a786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f03a786",
  null
  
)

export default component.exports